module.exports = __webpack_public_path__ + "static/media/about_banner.376c233d.png";